import { useEffect, ReactNode } from 'react';
import { useAppDispatch, useAppSelector } from '../slices/index';
import * as User from '../slices/userSlice';
import * as Cases from '../slices/casesSlice';
import * as UI from '../slices/uiSlice';
import { AnyAction } from '@reduxjs/toolkit';

interface ProtectedRouteProps {
    children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const dispatch = useAppDispatch();
    const user = useAppSelector(state => state.user);
    const cases = useAppSelector(state => state.cases);

    useEffect(() => {
        const loadCasesData = (userId: string, securityToken: string) => {
            dispatch(Cases.setLoaded(false));
            dispatch(Cases.setLoading(true));
            dispatch(Cases.getCases({ user: userId, security: securityToken }) as unknown as AnyAction)
                .then((result: any) => {
                    Cases.searchCases({ searchStr: cases.searchStr, isWishlisted: false });
                    try {
                        const action = JSON.parse(result.payload as string);
                        if (action.status !== 'OK') {
                            dispatch(UI.setError({ visible: true, message: 'Load Cases Failed' }));
                        }
                    } catch (e) {
                        dispatch(UI.setError({ visible: true, message: 'Load Cases Failed' }));
                    }
                });
        };

        if (user.token) {
            if (!cases.isLoaded) {
                loadCasesData(user.id, user.token);
            }
            return;
        }

        dispatch(User.getProfile() as unknown as AnyAction).then((r: any) => {
            const rp = JSON.parse(r?.payload);

            if (rp.status === "OK") {
                dispatch(Cases.setUser(rp.refer));
                loadCasesData(rp.type === 'developer' ? rp.developers?.[0]?.developerid : rp.introducer?.introducerid, rp.token);
            } else {
                window.location.replace('/');
            }
        })
    }, []);

    return (
        <>{children}</>
    );
};

export default ProtectedRoute;